import { DataPager } from './data-pager';
import { DataSort } from './data-sort';
import { DataFilter } from './data-filter';
import { Settings } from './settings';
import { Row } from './row';
import { rsltTypeInAPICall } from 'src/app/shared/functions/title';
import { PagedResult } from 'lib/ng-crud-table';
import { HeaderDataSource } from 'lib/ng-crud-table/base';
import 'rxjs/add/operator/takeWhile';

export class LocalDataSource {

  localRows: Row[] = [];

  constructor(
    private readonly dataFilter: DataFilter,
    private readonly pager: DataPager,
    private readonly sorter: DataSort,
    private readonly settings: Settings,
    private readonly rsltType: string,
    private headerDemoService: HeaderDataSource) { }

  setRows(data: Row[]) {
    this.dataFilter.clear();
    this.sorter.clear();
    this.pager.current = 1;
    this.localRows = (data) ? data.slice(0) : [];
  }

  getRows(): Row[] {
    if (this.localRows) {
      const data = this.dataFilter.filterRows(this.localRows, this.rsltType);
      this.pager.total = data.length;
      let rows = this.sorter.sortRows(data);
      if (!this.settings.virtualScroll) {
        rows = this.pager.pager(rows);
      }
      return rows;
    }

    //this.headerDemoService.getTotalRecords(rsltTypeInAPICall(this.rsltType)).subscribe(res => this.pager.total = res);
    //let rows: any[] = [];
    //this.headerDemoService.getItems(this.pager.perPage, this.pager.current, rsltTypeInAPICall(this.rsltType)).subscribe(res => {
    //  const data = JSON.parse(res) as any[];
    //  rows = this.sorter.sortRows(data);
    //});
    //return rows;
  }

  //async getServerRows(): Promise<Row[]> {
  //  if (this.localRows) {

  //    //const result = {
  //    //  items: pageData,
  //    //  _meta: {
  //    //    totalCount,//number of records totally
  //    //    pageCount,//number of records in current page
  //    //    currentPage,//page number selected
  //    //    perPage//selected option for number of records to be actually displayed
  //    //  }
  //    //} as PagedResult;

  //    return await this.headerDemoService.getItems(this.pager.perPage, this.pager.current, rsltTypeInAPICall(this.rsltType)).then(res =>
  //    {
  //      this.pager.total = res._meta.totalCount;
  //      let rows = this.sorter.sortRows(res.items);

  //      if (!this.settings.virtualScroll) {
  //        rows = this.pager.pager(rows);
  //      }
  //      return rows;
  //    });
  //  }
  //}

  post(newRow: Row) {
    this.localRows.push(newRow);
  }

  put(row: Row) {
    const rowIndex = this.localRows.findIndex(x => x.$$uid === row.$$uid);
    this.localRows[rowIndex] = row;
  }

  delete(row: Row) {
    const rowIndex = this.localRows.findIndex(x => x.$$uid === row.$$uid);
    this.localRows.splice(rowIndex, 1);
  }

}
